// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: the tidy Assistant chat's React contexts, kept free of stores so cards that read them stay
// light (the Agents card renders outside the chat too).

import type {Message} from '@app/features/messaging/models/MessagingMessage';
import type {AssistantChatKind} from '@fluxer/schema/src/domains/konvo/AssistantChat';
import type React from 'react';
import {createContext} from 'react';

/** The channel id of the Assistant chat whose chrome is shown around these messages (DMChannelView). */
export const AssistantChatScopeContext = createContext<string | null>(null);

export interface AssistantCardScope {
	message: Message;
	kind: AssistantChatKind | null;
	/** The card's ⋯ menu button, for cards that place it in their own header (the Agents card). */
	menuButton: React.ReactNode;
	/** "Live · updated 8:50" when this is the live Agents card, else nothing. */
	liveLabel: React.ReactNode;
}

/** Given by KonvoCard to what it draws, in the Assistant chat only. */
export const AssistantCardContext = createContext<AssistantCardScope | null>(null);
